import { Col, Row } from "react-bootstrap";
import { useIntl } from "react-intl";
import { SimpleFormTextarea } from "../../form/SimpleFormTextarea";
import { useField } from "formik";
import { getKeywordFromString } from "src/app/utils/keywordsHelper";
import { Planning } from "src/app/types/planning";

const BoostOrderForm = ({ planning }: { planning: Planning }) => {
    const { formatMessage } = useIntl();
    const [keywords] = useField("kwBoost");
    const keywordsCount = keywords.value ? getKeywordFromString(keywords.value)?.length : 0;

    return (
        <Row>
            <Col>
                <SimpleFormTextarea
                    name="kwBoost"
                    rows={20}
                    errorValues={{
                        min: ((planning.moneySite.content?.boost || 0) * planning.months) / 2,
                    }}
                    label={formatMessage(
                        { id: "common.field.boostKeywords" },
                        {
                            keywordsCount,
                        }
                    )}
                />
            </Col>
        </Row>
    );
};

export default BoostOrderForm;
